<template>
    <section class="list-items-section">
        <div class="fe-btn-translation" @click="$root.$emit('open_modal_translation', 'Not Paid', arrayTranslations)" v-if="globalTranslate">OPEN TRANSLATION</div>

        <div class="group_items">
            <div class="space-left"></div>
            <div class="empty-row full">
                <div class="icon not-paid">
                    <img src="/build/icons/warning-info.png">
                </div>
                <div class="title">
                    {{ $auth.user().status == 'unpaid' ? $t('not-paid.title') : $t('not-paid-first.title')}}
                </div>
                <div class="description narrow">
                    {{ $auth.user().status == 'unpaid' ? $t('not-paid.description') : $t('not-paid-first.description')}}
                </div>
                <div class="add-button">
                    <button class="button-tbf-blue" @click="openModalSubscription">{{ $auth.user().status == 'unpaid' ? $t('not-paid.button') : $t('not-paid-first.button')}}</button>
                </div>
            </div>
            <div class="space-right"></div>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return{
                arrayTranslations: [
                    'not-paid.title',
                    'not-paid-first.title',
                    'not-paid.description',
                    'not-paid-first.description',
                    'not-paid.button',
                    'not-paid-first.button'
                ]
            }
        },
        components: {
        },
        methods: {
            openModalSubscription(){
                this.$root.$emit('open_modal', 'change_subscription');
            }
        }
    }
</script>